import { cloneDeep } from "lodash";
import { meetingActions as actions } from "../actions";
import { initialState } from "../initialState";
import { createReducer, methodSwitcher } from "./utilities";

const { meeting } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setMeetingList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.list = data;
  return newState;
};

const setCurrentMeeting = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.current = data;
  return newState;
};

const actionMeeting = (state, { data, id, method }) => {
  const newState = cloneDeep(state);
  methodSwitcher(newState, data, id, method);
  return newState;
};

const clearCategoryCurrent = (state) => ({ ...state, categories: [] });

const setMeetingCategoryList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.categories = data;
  return newState;
};

const setMeetingCategoryAllList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.categoriesAll = data;
  return newState;
};

const actionMeetingCategory = (state, { data, id, method }) => {
  const newState = cloneDeep({ list: state.categories });
  methodSwitcher(newState, data, id, method);
  return { ...state, categories: newState.list };
};

const clearSubcategoryCurrent = (state) => ({ ...state, subcategories: {} });

const setMeetingSubcategoryList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.subcategories = data;
  return newState;
};

const actionMeetingSubcategory = (state, { data, id, method }) => {
  const newState = cloneDeep({ list: state.subcategories });
  methodSwitcher(newState, data, id, method);
  return { ...state, subcategories: newState.list };
};

export const meetingReducer = createReducer(meeting, {
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.LIST]: setMeetingList,
  [actions.CURRENT]: setCurrentMeeting,
  [actions.CUD]: actionMeeting,
  [actions.CATEGORY_CLEAR_CURRENT]: clearCategoryCurrent,
  [actions.CATEGORY_LIST]: setMeetingCategoryList,
  [actions.CATEGORY_CUD]: actionMeetingCategory,
  [actions.SUBCATEGORY_CLEAR_CURRENT]: clearSubcategoryCurrent,
  [actions.SUBCATEGORY_LIST]: setMeetingSubcategoryList,
  [actions.SUBCATEGORY_CUD]: actionMeetingSubcategory,
  [actions.CATEGORY_ALL_LIST]: setMeetingCategoryAllList
});
